import { createReducer } from '@reduxjs/toolkit';
import { bookOfferRequest, bookOfferSuccess, bookOfferFailure, clearBookingData } from './actions';

const initialState = {
  loading: false,
  data: null,
  error: null
};

const bookingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(bookOfferRequest, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(bookOfferSuccess, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(bookOfferFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(clearBookingData, (state) => {
      state.data = null;
      state.error = null;
    });
});

export default bookingReducer;